import React, { createContext, useState } from "react";

export interface BottomBarContextProps {
    isVisible: boolean;
    setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
    shouldFetchPartnerOrder: boolean;
    setFetchPartnerOrder: React.Dispatch<React.SetStateAction<boolean>>;
}

// Create the context with a default value that matches the shape of BottomBarContextProps
export const BottomBarContext = createContext<BottomBarContextProps>({
    isVisible: true,
    setIsVisible: () => {},
    shouldFetchPartnerOrder: false,
    setFetchPartnerOrder: () => {},
});

export const BottomBarProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [shouldFetchPartnerOrder, setFetchPartnerOrder] = useState(false);
    return (
        <BottomBarContext.Provider
            value={{ isVisible, setIsVisible, shouldFetchPartnerOrder, setFetchPartnerOrder }}
        >
            {children}
        </BottomBarContext.Provider>
    );
};
